import React from 'react';

import styled from '@emotion/styled';
import { mq, black02, green01, fontEn } from '../../_style';
import { css } from '@emotion/core';

const Container = styled.h3`
  display: block;
  line-height: 1;
  ${props =>
    props.inHeadingSet &&
    css`
    margin-bottom: 30px;
    ${mq.sp} {
      margin-bottom: 23px;
    }
  `}
  span {
    font-family: ${fontEn};
    color: ${green01};
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0.33em;
    line-height: 1;
    text-transform: uppercase;
    ${mq.sp} {
      font-size: 15px;
    }
  }
`;
export default class EnHeading extends React.Component {
  render() {
    return (
      <Container inHeadingSet={this.props.inHeadingSet}>
        <span>{this.props.children}</span>
      </Container>
    );
  }
}
